import LoginPage from "@/views/user/LoginPage.vue";
import SignupPage from "@/views/user/SignupPage.vue";
import OnboardingWelcomePage from "@/views/user/OnboardingWelcomePage.vue";
import loginGard from "./login_gard";

const user_routes = [
  {
    path: "/login",
    name: "login",
    params: {
      redir_on_success: "",
    },
    component: LoginPage,
    props: true,
  },
  {
    path: "/login/:user_id/:email_hash",
    name: "login_shared",
    component: LoginPage,
    props: true,
  },
  {
    path: "/signup",
    name: "signup",
    component: SignupPage,
    props: true,
  },
  {
    path: "/signup/:user_id/:email_hash",
    name: "signup_shared",
    component: SignupPage,
    props: true,
  },
  {
    name: "ask_password",
    path: "/ask_password",
    component: () => import("../views/user/AskPassword.vue"),
  },
  {
    name: "password_recovery",
    path: "/password_recovery",
    component: () => import("../views/user/PasswordRecovery.vue"),
  },
  {
    path: "/payment/pro/signup",
    name: "signupInvitedUsers",
    meta: {
      requiresAuth: false,
    },
    component: () => import("../views/payment/pro/SignupInvitedUsers.vue"),
  },
  {
    path: "/onboarding_welcome",
    name: "onboarding_welcome",
    component: OnboardingWelcomePage,
    beforeEnter: loginGard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/paywall/e-crf",
    name: "EcrfPaywall",
    component: () => import("../views/payment/EcrfPaywall.vue"),
  },
  {
    path: "/limit_warning",
    name: "limitWarning",
    component: () => import("../views/series/LimitWarning.vue"),
  },
  {
    path: "/offers",
    name: "offers",
    component: () => import("../views/payment/Offers.vue"),
  },
  {
    path: "/collab_warning",
    name: "CollabWarning",
    component: () => import("../views/payment/CollabWarning.vue"),
  },
  {
    path: "/payment/success/pro",
    name: "ProPostPayment",
    beforeEnter: loginGard,
    meta: {
      requiresAuth: true,
    },
    component: () => import("../views/payment/pro/ProPostPayment.vue"),
  },
  {
    path: "/user_settings",
    component: () => import("../views/user/ProfileHome.vue"),
    beforeEnter: loginGard,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "user_profile",
        path: "",
        component: () => import("../views/user/ProfilePersonalInfo.vue"),
      },
      {
        name: "user_password",
        path: "password",
        component: () => import("../views/user/ProfilePasswordChange.vue"),
      },
      {
        name: "user_email_prefs",
        path: "email_prefs",
        component: () => import("../views/user/ProfileEmailPreferences.vue"),
      },
      {
        name: "user_billing",
        path: "billing",
        component: () => import("../views/user/ProfileBilling.vue"),
      },
    ],

  },
];

export default user_routes;
